import { call, put } from "redux-saga/effects";
import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

import Api from "common/api";
import constants from "./constants";

export default {
  setFacebookSettings: function* (data) {
    const __name = constants.SET_FACEBOOK_SETTINGS;
    try {
      console.log("setFacebookSettings Data: ", data);
      const res = yield call(Api.setFacebookSettings, data.payload);
      console.log("setFacebookSettings Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setFacebookConversionStatus: function* (data) {
    const __name = constants.SET_FACEBOOK_CONVERSION_STATUS;
    try {
      console.log("setFacebookConversionStatus Data: ", data);
      const res = yield call(Api.setFacebookConversionStatus, data.payload);
      console.log("setFacebookConversionStatus Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  setFacebookConversionSettingStatus: function* (data) {
    const __name = constants.SET_FACEBOOK_CONVERSION_SETTING_STATUS;
    try {
      console.log("setFacebookConversionSettingStatus Data: ", data);
      const res = yield call(Api.setFacebookConversionSettingStatus, data.payload);
      console.log("setFacebookConversionSettingStatus Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookSettings: function* (data) {
    const __name = constants.GET_FACEBOOK_SETTINGS;
    try {
      console.log("getFacebookSettings Data: ", data);
      const res = yield call(Api.getFacebookSettings, data.payload);
      console.log("getFacebookSettings Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookDaSettings: function* (data) {
    const __name = constants.GET_FACEBOOK_DA_SETTINGS;
    try {
      console.log("getFacebookDaSettings Data: ", data);
      const res = yield call(Api.getFacebookDaSettings, data.payload);
      console.log("getFacebookDaSettings Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  changeSettingPage: function* (data) {
    const __name = constants.CHANGE_FACEBOOK_SETTING_PAGE;

    console.log("changeSettingPage: ", data);

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  getFacebookApiToken: function* (data) {
    const __name = constants.GET_FACEBOOK_API_TOKEN;
    try {
      console.log("getFacebookApiToken Data: ", data);
      const res = yield call(Api.getFacebookApiToken, data.payload);
      console.log("getFacebookApiToken Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookBusinessList: function* (data) {
    const __name = constants.GET_FACEBOOK_BUSINESS_LIST;
    try {
      console.log("getFacebookBusinessList Data: ", data);
      const res = yield call(Api.getFacebookBusinessList, data.payload);
      console.log("getFacebookBusinessList Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookAdsAccountList: function* (data) {
    const __name = constants.GET_FACEBOOK_ADS_ACCOUNT_LIST;
    try {
      console.log("getFacebookAdsAccountList Data: ", data);
      const res = yield call(Api.getFacebookGraphBusinessOwnedAdsAccounts, data.payload);
      console.log("getFacebookAdsAccountList Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res });
      yield call(resolvePromiseAction, data, res);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookPixelCodeList: function* (data) {
    const __name = constants.GET_FACEBOOK_PIXEL_CODE_LIST;
    try {
      console.log("getFacebookPixelCodeList Data: ", data);
      const res = yield call(Api.getFacebookPixelCodeList, data.payload);
      console.log("getFacebookPixelCodeList Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookPixelAgencies: function* (data) {
    const __name = constants.GET_FACEBOOK_PIXEL_AGENCIES;
    try {
      console.log("getFacebookPixelAgencies Data: ", data);
      const res = yield call(Api.getFacebookPixelAgencies, data.payload);
      console.log("getFacebookPixelAgencies Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookConversionLastSent: function* (data) {
    const __name = constants.GET_FACEBOOK_CONVERSION_LAST_SENT;
    try {
      console.log("getFacebookConversionLastSent Data: ", data);
      const res = yield call(Api.getFacebookConversionLastSent, data.payload);
      console.log("getFacebookConversionLastSent Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookCRMConversionLastSent: function* (data) {
    const __name = constants.GET_FACEBOOK_CRM_CONVERSION_LAST_SENT;
    try {
      console.log("getFacebookCRMConversionLastSent Data: ", data);
      const res = yield call(Api.getFacebookCRMConversionLastSent, data.payload);
      console.log("getFacebookCRMConversionLastSent Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookConversionSettingByPipeline: function* (data) {
    const __name = constants.GET_FACEBOOK_CONVERSION_SETTING_BY_PIPELINE;
    try {
      console.log("getFacebookConversionSettingByPipeline Data: ", data);
      const res = yield call(Api.getFacebookConversionSettingByPipeline, data.payload);
      console.log("getFacebookConversionSettingByPipeline Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  getFacebookAdsAccountAgencies: function* (data) {
    const __name = constants.GET_FACEBOOK_ADS_ACCOUNT_AGENCIES;
    try {
      console.log("getFacebookAdsAccountAgencies Data: ", data);
      const res = yield call(Api.getFacebookAdsAccountAgencies, data.payload);
      console.log("getFacebookAdsAccountAgencies Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  inviteFacebookAdsAccount: function* (data) {
    const __name = constants.INVITE_FACEBOOK_ADS_ACCOUNT;
    try {
      console.log("inviteFacebookAdsAccount Data: ", data);
      const res = yield call(Api.inviteFacebookAdsAccount, data.payload);
      console.log("inviteFacebookAdsAccount Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  syncFacebookSettingWithRdynamic: function* (data) {
    const __name = constants.SYNC_FACEBOOK_SETTING_WITH_RDYNAMIC;
    try {
      console.log("syncFacebookSettingWithRdynamic Data: ", data);
      const res = yield call(Api.syncFacebookSettingWithRdynamic, data.payload);
      console.log("syncFacebookSettingWithRdynamic Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  syncFacebookSettingWithRmp: function* (data) {
    const __name = constants.SYNC_FACEBOOK_SETTING_WITH_RMP;
    try {
      console.log("syncFacebookSettingWithRmp Data: ", data);
      const res = yield call(Api.syncFacebookSettingWithRmp, data.payload);
      console.log("syncFacebookSettingWithRmp Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  inviteFacebookPixels: function* (data) {
    const __name = constants.INVITE_FACEBOOK_PIXELS;
    try {
      console.log("inviteFacebookPixels Data: ", data);
      const res = yield call(Api.inviteFacebookPixels, data.payload);
      console.log("inviteFacebookPixels Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  rwidgetConversionDefaultValue: function* (data) {
    const __name = constants.RWIDGET_CONVERSION_DEFAULT_VALUE;
    console.log("in sagas rwidgetConversionDefaultValue");
    console.log(data);
    console.log("api url");
    console.log(Api.rwidgetConversionDefaultValue);
    try {
      console.log("rwidgetConversionDefaultValue Data: ", data);
      const res = yield call(Api.rwidgetConversionDefaultValue, data.params);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  getRwidgetConversionDefaultValue: function* (data) {
    const __name = constants.GET_RWIDGET_CONVERSION_DEFAULT_VALUE;
    try {
      console.log("in sagas getRwidgetConversionDefaultValue Data: ", data);
      const res = yield call(Api.getRwidgetConversionDefaultValue, data.payload);
      console.log("getRwidgetConversionDefaultValue Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.dta);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookPageId api
   * @param {*} data
   */
  getFacebookPageId: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_ID;
    try {
      const res = yield call(Api.getFacebookPageId, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookFormList api
   * @param {*} data
   */
  getFacebookFormList: function* (data) {
    const __name = constants.GET_FACEBOOK_FORM_LIST;
    try {
      const res = yield call(Api.getFacebookFormList, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getAllLeadFormSettings api
   * @param {*} data
   */
  getAllLeadFormSettings: function* (data) {
    const __name = constants.GET_ALL_LEAD_FORM_SETTINGS;
    try {
      const res = yield call(Api.getAllLeadFormSettings, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call setFacebookAccount api
   * @param {*} data
   */
  setFacebookAccount: function* (data) {
    const __name = constants.SET_FACEBOOK_ACCOUNT;
    try {
      const res = yield call(Api.setFacebookAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookAccount api
   * @param {*} data
   */
  getFacebookAccount: function* (data) {
    const __name = constants.GET_FACEBOOK_ACCOUNT;
    try {
      const res = yield call(Api.getFacebookAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call switchLeadFormStatus api
   * @param {*} data
   */
  switchLeadFormStatus: function* (data) {
    const __name = constants.SWITCH_LEAD_FORM_STATUS;
    try {
      const res = yield call(Api.switchLeadFormStatus, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getLeadFormSetting api
   * @param {*} data
   */
  getLeadFormSetting: function* (data) {
    const __name = constants.GET_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.getLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookPageSetting api
   * @param {*} data
   */
  getFacebookPageSetting: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_SETTING;
    try {
      const res = yield call(Api.getFacebookPageSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getGoogleSetting api
   * @param {*} data
   */
  getGoogleSetting: function* (data) {
    const __name = constants.GET_GOOGLE_SETTING;
    try {
      const res = yield call(Api.getGoogleSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getCRMSetting api
   * @param {*} data
   */
  getCRMSetting: function* (data) {
    const __name = constants.GET_CRM_SETTING;
    try {
      const res = yield call(Api.getCRMSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call setLeadFormSetting api
   * @param {*} data
   */
  setLeadFormSetting: function* (data) {
    const __name = constants.SET_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.setLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getPageSetting api
   * @param {*} data
   */
  getPageSetting: function* (data) {
    const __name = constants.GET_PAGE_SETTING;
    try {
      const res = yield call(Api.getPageSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookUserInfo api
   * @param {*} data
   */
  getFacebookUserInfo: function* (data) {
    const __name = constants.GET_FACEBOOK_USER_INFO;
    try {
      const res = yield call(Api.getFacebookUserInfo, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookNewAccessToken api
   * @param {*} data
   */
  getFacebookNewAccessToken: function* (data) {
    const __name = constants.GET_FACEBOOK_NEW_ACCESS_TOKEN;
    try {
      const res = yield call(Api.getFacebookNewAccessToken, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookPageAccessToken api
   * @param {*} data
   */
  getFacebookPageAccessToken: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_ACCESS_TOKEN;
    try {
      const res = yield call(Api.getFacebookPageAccessToken, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookPageByUserId api
   * @param {*} data
   */
  getFacebookPageByUserId: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_BY_USER_ID;
    try {
      const res = yield call(Api.getFacebookPageByUserId, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * change page url input
   * @param {*} data
   */
  changePageUrlInput: function* (data) {
    const __name = constants.CHANGE_PAGE_URL_INPUT;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * change page form select type
   * @param {*} data
   */
  changePageFormSelectType: function* (data) {
    const __name = constants.CHANGE_PAGE_FORM_SELECT_TYPE;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set checked form items
   * @param {*} data
   */
  setCheckedFormItems: function* (data) {
    const __name = constants.SET_CHECKED_FORM_ITEMS;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call archiveLeadFormSetting api
   * @param {*} data
   */
  archiveLeadFormSetting: function* (data) {
    const __name = constants.ARCHIVE_LEAD_FORM_SETTING;
    try {
      const res = yield call(Api.archiveLeadFormSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * set facebook connected
   * @param {*} data
   */
  setFbConnected: function* (data) {
    const __name = constants.SET_FB_CONNECTED;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set facebook disconnected
   * @param {*} data
   */
  setFbDisconnected: function* (data) {
    const __name = constants.SET_FB_DISCONNECTED;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google connected
   * @param {*} data
   */
  setGoogleConnected: function* (data) {
    const __name = constants.SET_GOOGLE_CONNECTED;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set google disconnected
   * @param {*} data
   */
  setGoogleDisconnected: function* (data) {
    const __name = constants.SET_GOOGLE_DISCONNECTED;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * change sheets url input
   * @param {*} data
   */
  changeSheetsUrlInput: function* (data) {
    const __name = constants.CHANGE_SHEETS_URL_INPUT;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getFacebookPageList api
   * @param {*} data
   */
  getFacebookPageList: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_LIST;
    try {
      const res = yield call(Api.getFacebookPageList, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getUserAccessToken api
   * @param {*} data
   */
  getUserAccessToken: function* (data) {
    const __name = constants.GET_USER_ACCESS_TOKEN;
    try {
      const res = yield call(Api.getUserAccessToken, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getFacebookPageListMore api
   * @param {*} data
   */
  getFacebookPageListMore: function* (data) {
    const __name = constants.GET_FACEBOOK_PAGE_LIST_MORE;
    try {
      const res = yield call(Api.getFacebookPageListMore, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set validate facebook lead form
   * @param {*} data
   */
  setValidateFacebookLeadForm: function* (data) {
    const __name = constants.SET_VALIDATE_FACEBOOK_LEAD_FORM;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set duplicate facebook form
   * @param {*} data
   */
  setDuplicateFacebookForm: function* (data) {
    const __name = constants.SET_DUPLICATE_FACEBOOK_FORM;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getGoogleSheetsCRMConversionsLastSend API
   * @param {*} data
   */
  getGoogleSheetsCRMConversionsLastSend: function* (data) {
    const __name = constants.GET_GOOGLE_SHEETS_CRM_CONVERSIONS_LAST_SEND;
    try {
      const res = yield call(Api.getGoogleSheetsCRMConversionsLastSend, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call getDetailsPixelId api
   * @param {*} data
   */
  getDetailsPixelId: function* (data) {
    const __name = constants.GET_DETAILS_PIXEL_ID;
    try {
      const res = yield call(Api.getDetailsPixelId, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set modified data of google sheets
   * @param {*} data
   */
  updateSheetsModifiedData: function* (data) {
    const __name = constants.UPDATE_SHEETS_MODIFIED_DATA;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call updateFBLeadFormSettingErrorStatus api
   * @param {*} data
   */
  updateFBLeadFormSettingErrorStatus: function* (data) {
    const __name = constants.UPDATE_FB_LEAD_FORM_SETTING_ERROR_STATUS;
    try {
      const res = yield call(Api.updateFBLeadFormSettingErrorStatus, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set file info error
   * @param {*} data
   */
  setFileInfoError: function* (data) {
    const __name = constants.SET_FILE_INFO_ERROR;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set loading
   * @param {*} data
   */
  setFacebookLoading: function* (data) {
    const __name = constants.SET_FACEBOOK_LOADING;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set facebook form loading
   * @param {*} data
   */
  setFacebookFormLoading: function* (data) {
    const __name = constants.SET_FACEBOOK_FORM_LOADING;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set facebook error
   * @param {*} data
   */
  setFacebookError: function* (data) {
    const __name = constants.SET_FACEBOOK_ERROR;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set facebook connection loading
   * @param {*} data
   */
  setFBConnectionLoading: function* (data) {
    const __name = constants.SET_FB_CONNECTION_LOADING;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set crm conversions loading
   * @param {*} data
   */
  setCRMConversionsLoading: function* (data) {
    const __name = constants.SET_CRM_CONVERSIONS_LOADING;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
